import actions from './actions'

export default function ProtocolReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
      }
    case actions.SAVE_PROTOCOLHISTORY_RECEIVED:
      return {
        ...state,
        loading: false,
        protocolHistorySaveResult: action.payload,
      }

    case actions.SAVE_PROTOCOLHISTORY_RESET_RESULT_RECEIVED:
      return {
        ...state,
        loading: false,
        protocolHistorySaveResult: null,
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.message,
      }
    default:
      return state
  }
}
